// Staff Purchase (68_StaffPurchase.jsx — task #1132, the Global Staff Purchase Procedure Rev. 3, 01/11/2026).
const en = {
  st_overlimit: "Over-limit approval",
  charged: "Charged to the limit: {{v}} (1 {{from}} = {{rate}} {{to}}, the year's fixed rate)",
  chargedShort: "= {{v}} against your limit",
  overApproved: "Over-limit purchase approved by {{by}} on {{at}}",
  overNeeds: "This request goes over the limit. It needs a separate over-limit approval first; the normal approval follows.",
  approveOver: "Approve over-limit",
  proratedShort: "prorated for the months left",
  limitFrom: "{{v}} at the year's fixed rate",
  onHold: "{{e}} purchases are on hold until its approver has a portal account.",
  fxMissing: "The {{y}} fixed rate {{from}} → {{to}} is not set yet, so the limit cannot be worked out. Tina sets it in Setup → Fixed rates.",
  priceIn: "Prices in",
  krwOption: "KRW — HINC website",
  krwRate: "Charged to your limit at the {{y}} fixed rate: 1 KRW = {{rate}} {{to}}.",
  krwRateMissing: "The {{y}} fixed rate KRW → {{to}} is not set yet — ask Tina Lee.",
  overNote: "Over your limit: you can still send it, and it goes to an over-limit approval first (procedure section 4).",
  submitOver: "Send for over-limit approval",
  seniorLimit: "Senior Mgr+ limit",
  seniorHint: "Blank = twice the annual limit.",
  limitCurrency: "Limits set in",
  limitCcyHint: "Only when the limits are set in another currency than the one shown (HEMY: MYR, shown in SGD at the year's fixed rate).",
  managerEmails: "Staff purchase managers",
  managerHint: "They read this entity's ledger. Several e-mails, separated by commas.",
  krwPurchase: "Staff may buy on the HINC website in KRW",
  priceCurrency: "Price currency",
  priceCcyHint: "Blank = the entity's currency; KRW for HINC website prices.",
  setup_fx: "Fixed rates",
  addFx: "Add rate",
  editFx: "Edit rate",
  fxYear: "Year",
  fxFrom: "From",
  fxTo: "To",
  fxPair: "Pair",
  fxRate: "Rate",
  fxRateHint: "1 From = this many To.",
  fxNote: "Note",
  fxBy: "Set by",
  fxHint: "One fixed rate per pair, set each January and used for the whole year: KRW → VND / CNY / SGD for purchases on the HINC website, MYR → SGD for HEMY's limit.",
  noFx: "No fixed rates yet.",
  tourCardsT: "Your limit this year",
  tourCardsB: "Your annual limit, what is already approved, what a pending request holds, and what is left. Senior Mgr+ have twice the standard limit; a person who became eligible part-way through the year gets a prorated limit.",
  tourPledgeT: "Sign the pledge once",
  tourPledgeB: "Before your first request, read the non-resale pledge, type your full name and tick that you agree. It is kept with the procedure version you signed.",
  tourFormT: "Ask for a purchase",
  tourFormB: "Add each item with its category and local SRP: the discount, the discounted price and what stays of your limit are worked out as you type. Send it and it goes to your entity's approver.",
  tourQueueT: "Approvals",
  tourQueueB: "Requests waiting for your decision, and every request you may see. Open one to approve or reject it, then record the discount code and what was actually paid.",
  tourLedgerT: "The ledger",
  tourLedgerB: "Every employee's limit, approved, pending and remaining for the year, with sort, filter and an Excel copy for the monthly review.",
  tourSetupT: "Setup",
  tourSetupB: "For the module's admins: entities, limits and approvers, the discount categories, the employee list and the price list — each with Add, Edit and Delete.",
  searchAccount: "Type a name or e-mail to search",
  cancel: "Cancel",
  edit: "Edit",
  delete: "Delete",
  deleteTitle: "Delete this row?",
  deleteBody: "This cannot be undone. A row that requests, pledges, employees or prices still use is not deleted — switch it off (Active) instead.",
  deleted: "Deleted.",
  hidden: "Used by earlier requests, so it is hidden from the price list rather than deleted.",
  on: "Active",
  off: "Off",
  addEntity: "Add entity",
  editEntity: "Edit entity",
  addCategory: "Add category",
  editCategory: "Edit category",
  addStaff: "Add employee",
  editStaff: "Edit employee",
  addPrice: "Add price",
  editPrice: "Edit price",
  entityCode: "Entity code",
  region: "Region",
  approverHint: "Several e-mails, separated by commas — any one of them decides.",
  sortOrder: "Order",
  sortHint: "Smaller numbers come first in the request form.",
  categoryHint: "A request line keeps the % it was asked with — changing a category changes new requests only.",
  fullNameField: "Full name",
  department: "Department",
  jobTitle: "Job title",
  remarks: "Remarks",
  seniorField: "Senior Manager or above (twice the standard limit)",
  joinedHint: "Eligible three months later.",
  itemCode: "Item code",
  color: "Colour",
  srpHint: "In the entity's currency.",
  noApprover: "no approver with an account — goes to the admins",
  shownOf: '{{n}} of {{total}} rows shown',
  clearTools: 'Clear sort & filters',
  nav: 'Staff Purchase',
  title: 'Staff Purchase',
  sub: 'Buy Helinox products at the staff discount: see your limit for the year, sign the pledge once, send a request to your entity approver.',
  tab_mine: 'My purchases',
  tab_queue: 'Approvals',
  tab_ledger: 'Ledger',
  tab_setup: 'Setup',
  loading: 'Loading…',
  close: 'Close',
  notOnList: 'You are not on the staff purchase employee list yet, or your portal account is not linked to your name on it. Ask Tina Lee or the HEVN portal team to link it.',
  limitYear: 'Limit {{y}}',
  noLimitShort: 'No limit',
  seniorNote: "Senior Mgr+ — twice the standard limit",
  prorated: 'Prorated from {{base}} (eligible part-way through the year)',
  approved: 'Approved',
  pending: 'Pending',
  pendingHeld: '+ {{v}} pending, held against the limit',
  remaining: 'Remaining',
  approverIs: 'Approver: {{who}}',
  eligible: 'Eligible from',
  eligibleYes: 'Probation done — you can buy',
  eligibleNo: 'Not yet — three months after joining',
  pledgeTitle: 'Pledge Against Resale of Discounted Products',
  pledgeEnNote: 'Procedure {{v}}, Appendix. The pledge is shown in English, the wording you sign.',
  fullName: 'Full name (as your signature)',
  birth: 'Date of birth',
  agree: 'I have read and agree to the pledge above',
  sign: 'Sign the pledge',
  pledgeSigned: 'Pledge signed on {{at}} ({{v}})',
  newRequest: 'New request',
  noPriceList: 'The price list for your entity is not loaded yet — type the product, pick its category and enter the local SRP.',
  product: 'Product',
  productPh: 'Product name and colour',
  typeItem: '— type a product not on the list —',
  limited: 'limited / collab — separate approval',
  category: 'Category',
  pickCategory: 'Pick the category',
  qty: 'Qty',
  srp: 'SRP',
  srpCur: 'SRP ({{cur}})',
  net: 'Discounted',
  total: 'Total',
  addItem: 'Add item',
  remove: 'Remove',
  afterThis: 'Remaining after this request: {{v}}',
  noLimit: 'No annual limit.',
  channel: 'Where you will buy',
  note: 'Note to the approver',
  submit: 'Send for approval',
  sent: '{{no}} sent to your approver.',
  myRequests: 'My requests {{y}}',
  noRequests: 'No requests.',
  no: 'No.',
  employee: 'Employee',
  entity: 'Entity',
  date: 'Date',
  items: 'Items',
  status: 'Status',
  approver: 'Approver',
  code: 'Discount code',
  action: 'Action',
  review: 'Review',
  open: 'Open',
  st_pending: 'Pending',
  st_approved: 'Approved',
  st_rejected: 'Rejected',
  st_cancelled: 'Cancelled',
  created: 'Sent {{at}} by {{by}}',
  remainingBefore: 'Remaining before this request: {{v}} of {{limit}}',
  decided: 'Decided by {{by}} on {{at}}',
  notePh: 'Note (optional — the reason, if you reject)',
  approve: 'Approve',
  reject: 'Reject',
  codePh: 'The code issued for the website',
  paid: 'Paid ({{cur}})',
  paidHint: 'What was actually paid counts against the limit once entered; until then the discounted total does.',
  save: 'Save',
  saved: 'Saved.',
  cancelReq: 'Cancel this request',
  waitingForYou: 'Waiting for your decision',
  allRequests: 'All requests you can see this year',
  all: 'All',
  account: 'Portal account',
  notLinked: 'not linked',
  setup_entities: 'Entities & limits',
  setup_categories: 'Discount categories',
  setup_staff: 'Employees',
  setup_prices: 'Price list',
  currency: 'Currency',
  annualLimit: 'Annual limit',
  approverEmails: 'Approver e-mail(s)',
  approverName: 'Approver name',
  settingsNote: 'Own purchase of an approver goes to {{self}}. Module admins: {{admins}}. Mail: {{mail}}.',
  discount: 'Discount',
  active: 'Active',
  search: 'Search name, entity, e-mail',
  importStaff: 'Import employee list (.xlsx)',
  staffImported: '{{n}} rows read: {{a}} added, {{u}} updated.{{m}}',
  missingList: 'No longer on the list (left active)',
  joined: 'Joined',
  importPrices: 'Import price list (.xlsx)',
  priceHint: "Columns: Entity, Item code, Product, Color, Category, SRP, Limited, Currency (blank = the entity's; KRW for HINC website prices). One file may carry several entities; each entity in it is replaced.",
  pricesImported: '{{n}} rows read for {{e}}.{{r}}',
  refused: 'Refused',
  noPrices: 'No price list loaded yet.',
};

const ko = {
  st_overlimit: "한도 초과 승인 대기",
  charged: "한도 차감: {{v}} (1 {{from}} = {{rate}} {{to}}, 연간 고정 환율)",
  chargedShort: "한도 기준 {{v}}",
  overApproved: "한도 초과 구매 승인: {{by}}, {{at}}",
  overNeeds: "이 신청은 한도를 초과합니다. 먼저 한도 초과 승인을 받은 뒤 일반 승인을 받습니다.",
  approveOver: "한도 초과 승인",
  proratedShort: "잔여 개월 비례",
  limitFrom: "{{v}}, 연간 고정 환율 적용",
  onHold: "{{e}} 구매는 승인자에게 포털 계정이 생길 때까지 보류됩니다.",
  fxMissing: "{{y}}년 고정 환율 {{from}} → {{to}}가 아직 없어 한도를 계산할 수 없습니다. Tina가 설정 → 고정 환율에서 입력합니다.",
  priceIn: "가격 통화",
  krwOption: "KRW — HINC 웹사이트",
  krwRate: "{{y}}년 고정 환율로 한도에서 차감: 1 KRW = {{rate}} {{to}}.",
  krwRateMissing: "{{y}}년 KRW → {{to}} 고정 환율이 아직 없습니다 — Tina Lee에게 문의하세요.",
  overNote: "한도 초과: 그래도 보낼 수 있으며, 먼저 한도 초과 승인을 받습니다(절차서 4항).",
  submitOver: "한도 초과 승인 요청",
  seniorLimit: "Senior Mgr+ 한도",
  seniorHint: "비워 두면 연간 한도의 2배.",
  limitCurrency: "한도 통화",
  limitCcyHint: "표시 통화와 다른 통화로 한도를 정할 때만 (HEMY: MYR, 연간 고정 환율로 SGD 표시).",
  managerEmails: "임직원 구매 담당자",
  managerHint: "이 법인의 한도 대장을 볼 수 있습니다. 여러 이메일은 쉼표로 구분.",
  krwPurchase: "직원이 HINC 웹사이트에서 KRW로 구매 가능",
  priceCurrency: "가격 통화",
  priceCcyHint: "비워 두면 법인 통화, HINC 웹사이트 가격은 KRW.",
  setup_fx: "고정 환율",
  addFx: "환율 추가",
  editFx: "환율 수정",
  fxYear: "연도",
  fxFrom: "원 통화",
  fxTo: "대상 통화",
  fxPair: "통화쌍",
  fxRate: "환율",
  fxRateHint: "1 원 통화 = 대상 통화 금액.",
  fxNote: "비고",
  fxBy: "입력자",
  fxHint: "통화쌍별 고정 환율 1개를 매년 1월에 정해 1년간 사용: HINC 웹사이트 구매용 KRW → VND / CNY / SGD, HEMY 한도용 MYR → SGD.",
  noFx: "아직 고정 환율이 없습니다.",
  tourCardsT: "올해 한도",
  tourCardsB: "연간 한도, 이미 승인된 금액, 대기 중인 신청이 잡고 있는 금액, 잔여 금액입니다. Senior Mgr+는 표준 한도의 2배이고, 연중에 자격을 얻은 사람은 한도가 비례 적용됩니다.",
  tourPledgeT: "서약서 1회 서명",
  tourPledgeB: "첫 신청 전에 재판매 금지 서약서를 읽고 성명을 입력한 뒤 동의에 체크하세요. 서명한 절차서 버전과 함께 보관됩니다.",
  tourFormT: "구매 신청",
  tourFormB: "품목마다 카테고리와 현지 SRP를 넣으면 할인율, 할인가, 남는 한도가 바로 계산됩니다. 보내면 소속 법인 승인자에게 갑니다.",
  tourQueueT: "승인",
  tourQueueB: "결정을 기다리는 신청과 볼 수 있는 모든 신청입니다. 열어서 승인/반려하고, 할인 코드와 실결제액을 기록합니다.",
  tourLedgerT: "한도 대장",
  tourLedgerB: "직원별 연간 한도, 승인, 대기, 잔여 금액입니다. 정렬·필터가 되고 월간 검토용 Excel로 받을 수 있습니다.",
  tourSetupT: "설정",
  tourSetupB: "모듈 관리자용: 법인·한도·승인자, 할인 카테고리, 직원 명단, 가격표를 추가·수정·삭제합니다.",
  searchAccount: "이름 또는 이메일로 검색",
  cancel: "취소",
  edit: "수정",
  delete: "삭제",
  deleteTitle: "이 항목을 삭제할까요?",
  deleteBody: "되돌릴 수 없습니다. 신청·서약서·직원·가격이 아직 사용 중인 항목은 삭제되지 않으니, 대신 사용(Active)을 끄세요.",
  deleted: "삭제했습니다.",
  hidden: "이전 신청에서 사용되어 삭제 대신 가격표에서 숨겼습니다.",
  on: "사용",
  off: "중지",
  addEntity: "법인 추가",
  editEntity: "법인 수정",
  addCategory: "카테고리 추가",
  editCategory: "카테고리 수정",
  addStaff: "직원 추가",
  editStaff: "직원 수정",
  addPrice: "가격 추가",
  editPrice: "가격 수정",
  entityCode: "법인 코드",
  region: "지역",
  approverHint: "여러 이메일은 쉼표로 구분 — 그중 한 명이 결정합니다.",
  sortOrder: "순서",
  sortHint: "숫자가 작을수록 신청서에서 먼저 나옵니다.",
  categoryHint: "신청 품목은 신청 당시 %를 유지합니다 — 카테고리를 바꿔도 새 신청에만 적용됩니다.",
  fullNameField: "성명",
  department: "부서",
  jobTitle: "직책",
  remarks: "비고",
  seniorField: "Senior Manager 이상 (표준 한도의 2배)",
  joinedHint: "3개월 후부터 자격이 생깁니다.",
  itemCode: "품목 코드",
  color: "색상",
  srpHint: "법인 통화 기준.",
  noApprover: "계정 있는 승인자 없음 — 관리자에게",
  shownOf: '{{total}}행 중 {{n}}행 표시',
  clearTools: '정렬·필터 해제',
  nav: '임직원 구매',
  title: '임직원 구매',
  sub: '임직원 할인으로 Helinox 제품 구매: 올해 한도 확인, 서약서 1회 서명, 법인 승인자에게 신청.',
  tab_mine: '내 구매',
  tab_queue: '승인',
  tab_ledger: '한도 대장',
  tab_setup: '설정',
  loading: '불러오는 중…',
  close: '닫기',
  notOnList: '아직 임직원 구매 명단에 없거나, 포털 계정이 명단의 이름과 연결되지 않았습니다. Tina Lee 또는 HEVN 포털 팀에 연결을 요청하세요.',
  limitYear: '{{y}} 한도',
  noLimitShort: '한도 없음',
  seniorNote: "Senior Mgr+ — 표준 한도의 2배",
  prorated: '{{base}}에서 비례 적용 (연중 자격 취득)',
  approved: '승인',
  pending: '대기',
  pendingHeld: '+ 대기 {{v}}, 한도에서 보류',
  remaining: '잔여',
  approverIs: '승인자: {{who}}',
  eligible: '자격 시작일',
  eligibleYes: '수습 완료 — 구매 가능',
  eligibleNo: '아직 — 입사 후 3개월',
  pledgeTitle: '할인 제품 재판매 금지 서약서',
  pledgeEnNote: '절차서 {{v}} 부록. 서약서는 서명하는 원문인 영어로 표시됩니다.',
  fullName: '성명 (서명)',
  birth: '생년월일',
  agree: '위 서약서를 읽고 동의합니다',
  sign: '서약서 서명',
  pledgeSigned: '서약서 서명일 {{at}} ({{v}})',
  newRequest: '신규 신청',
  noPriceList: '소속 법인의 가격표가 아직 없습니다 — 제품명을 입력하고 카테고리를 선택한 뒤 현지 SRP를 입력하세요.',
  product: '제품',
  productPh: '제품명과 색상',
  typeItem: '— 목록에 없는 제품 직접 입력 —',
  limited: '한정판 / 콜라보 — 별도 승인',
  category: '카테고리',
  pickCategory: '카테고리 선택',
  qty: '수량',
  srp: 'SRP',
  srpCur: 'SRP ({{cur}})',
  net: '할인가',
  total: '합계',
  addItem: '품목 추가',
  remove: '삭제',
  afterThis: '이번 신청 후 잔여: {{v}}',
  noLimit: '연간 한도 없음.',
  channel: '구매처',
  note: '승인자에게 메모',
  submit: '승인 요청',
  sent: '{{no}} 승인자에게 전송했습니다.',
  myRequests: '내 신청 {{y}}',
  noRequests: '신청 없음.',
  no: '번호',
  employee: '직원',
  entity: '법인',
  date: '날짜',
  items: '품목',
  status: '상태',
  approver: '승인자',
  code: '할인 코드',
  action: '작업',
  review: '검토',
  open: '열기',
  st_pending: '대기',
  st_approved: '승인',
  st_rejected: '반려',
  st_cancelled: '취소',
  created: '{{at}} {{by}} 신청',
  remainingBefore: '신청 전 잔여: {{v}} / {{limit}}',
  decided: '{{by}} 결정, {{at}}',
  notePh: '메모 (선택 — 반려 시 사유)',
  approve: '승인',
  reject: '반려',
  codePh: '웹사이트용으로 발급된 코드',
  paid: '실결제액 ({{cur}})',
  paidHint: '실결제액을 입력하면 그 금액이 한도에서 차감되고, 그 전까지는 할인 합계가 차감됩니다.',
  save: '저장',
  saved: '저장했습니다.',
  cancelReq: '이 신청 취소',
  waitingForYou: '결정 대기',
  allRequests: '올해 볼 수 있는 모든 신청',
  all: '전체',
  account: '포털 계정',
  notLinked: '미연결',
  setup_entities: '법인 · 한도',
  setup_categories: '할인 카테고리',
  setup_staff: '직원',
  setup_prices: '가격표',
  currency: '통화',
  annualLimit: '연간 한도',
  approverEmails: '승인자 이메일',
  approverName: '승인자 이름',
  settingsNote: '승인자 본인 구매는 {{self}}에게. 모듈 관리자: {{admins}}. 메일: {{mail}}.',
  discount: '할인',
  active: '사용',
  search: '이름, 법인, 이메일 검색',
  importStaff: '직원 명단 가져오기 (.xlsx)',
  staffImported: '{{n}}행 읽음: 추가 {{a}}, 갱신 {{u}}.{{m}}',
  missingList: '명단에서 빠짐 (사용 상태 유지)',
  joined: '입사일',
  importPrices: '가격표 가져오기 (.xlsx)',
  priceHint: "열: Entity, Item code, Product, Color, Category, SRP, Limited, Currency (비우면 법인 통화, HINC 웹사이트 가격은 KRW). 한 파일에 여러 법인 가능, 파일에 있는 법인은 통째로 교체됩니다.",
  pricesImported: '{{e}} {{n}}행 읽음.{{r}}',
  refused: '거부',
  noPrices: '아직 가격표가 없습니다.',
};

const vi = {
  st_overlimit: "Chờ duyệt vượt hạn mức",
  charged: "Trừ vào hạn mức: {{v}} (1 {{from}} = {{rate}} {{to}}, tỷ giá cố định của năm)",
  chargedShort: "= {{v}} trừ vào hạn mức",
  overApproved: "{{by}} đã duyệt vượt hạn mức ngày {{at}}",
  overNeeds: "Yêu cầu này vượt hạn mức: cần được duyệt vượt hạn mức trước, sau đó mới duyệt bình thường.",
  approveOver: "Duyệt vượt hạn mức",
  proratedShort: "tính theo tỷ lệ số tháng còn lại",
  limitFrom: "{{v}} theo tỷ giá cố định của năm",
  onHold: "Mua hàng của {{e}} tạm dừng cho tới khi người duyệt có tài khoản portal.",
  fxMissing: "Chưa có tỷ giá cố định {{from}} → {{to}} năm {{y}} nên chưa tính được hạn mức. Tina nhập ở Cài đặt → Tỷ giá cố định.",
  priceIn: "Giá tính bằng",
  krwOption: "KRW — web HINC",
  krwRate: "Trừ vào hạn mức theo tỷ giá cố định năm {{y}}: 1 KRW = {{rate}} {{to}}.",
  krwRateMissing: "Chưa có tỷ giá cố định KRW → {{to}} năm {{y}} — hỏi Tina Lee.",
  overNote: "Vượt hạn mức: vẫn gửi được, yêu cầu sẽ qua bước duyệt vượt hạn mức trước (quy trình mục 4).",
  submitOver: "Gửi duyệt vượt hạn mức",
  seniorLimit: "Hạn mức Sr Mgr+",
  seniorHint: "Để trống = gấp đôi hạn mức năm.",
  limitCurrency: "Hạn mức tính bằng",
  limitCcyHint: "Chỉ điền khi hạn mức đặt bằng tiền khác tiền hiển thị (HEMY: MYR, hiện bằng SGD theo tỷ giá cố định của năm).",
  managerEmails: "Người quản lý mua hàng nhân viên",
  managerHint: "Được xem Sổ hạn mức của pháp nhân này. Nhiều email cách nhau bằng dấu phẩy.",
  krwPurchase: "Nhân viên có thể mua trên web HINC bằng KRW",
  priceCurrency: "Tiền tệ của giá",
  priceCcyHint: "Để trống = tiền của pháp nhân; giá trên web HINC thì KRW.",
  setup_fx: "Tỷ giá cố định",
  addFx: "Thêm tỷ giá",
  editFx: "Sửa tỷ giá",
  fxYear: "Năm",
  fxFrom: "Từ",
  fxTo: "Sang",
  fxPair: "Cặp tiền",
  fxRate: "Tỷ giá",
  fxRateHint: "1 đơn vị Từ = bao nhiêu đơn vị Sang.",
  fxNote: "Ghi chú",
  fxBy: "Người nhập",
  fxHint: "Mỗi cặp tiền một tỷ giá cố định, đặt mỗi tháng 1 và dùng cả năm: KRW → VND / CNY / SGD cho đơn mua trên web HINC, MYR → SGD cho hạn mức HEMY.",
  noFx: "Chưa có tỷ giá cố định.",
  tourCardsT: "Hạn mức năm nay",
  tourCardsB: "Hạn mức năm, số đã duyệt, số đang giữ cho yêu cầu chờ duyệt và số còn lại. Senior Mgr+ được gấp đôi hạn mức chuẩn; ai đủ điều kiện giữa năm thì hạn mức tính theo tỷ lệ.",
  tourPledgeT: "Ký cam kết một lần",
  tourPledgeB: "Trước yêu cầu đầu tiên, đọc cam kết không bán lại, gõ họ tên và tick đồng ý. Cam kết được lưu kèm phiên bản quy trình bạn đã ký.",
  tourFormT: "Gửi yêu cầu mua",
  tourFormB: "Thêm từng món với nhóm hàng và SRP địa phương: % giảm, giá sau giảm và hạn mức còn lại được tính ngay khi gõ. Gửi đi là tới người duyệt của pháp nhân bạn.",
  tourQueueT: "Duyệt",
  tourQueueB: "Các yêu cầu đang chờ bạn quyết định và mọi yêu cầu bạn được xem. Mở một yêu cầu để duyệt hoặc từ chối, rồi ghi mã giảm giá và số tiền thực trả.",
  tourLedgerT: "Sổ hạn mức",
  tourLedgerB: "Hạn mức, đã duyệt, đang chờ và còn lại của từng nhân viên trong năm; có sort, filter và xuất Excel cho buổi rà soát hằng tháng.",
  tourSetupT: "Cài đặt",
  tourSetupB: "Dành cho quản trị module: pháp nhân, hạn mức và người duyệt, nhóm giảm giá, danh sách nhân viên và bảng giá — đều có Thêm, Sửa, Xóa.",
  searchAccount: "Gõ tên hoặc email để tìm",
  cancel: "Hủy",
  edit: "Sửa",
  delete: "Xóa",
  deleteTitle: "Xóa dòng này?",
  deleteBody: "Không hoàn tác được. Dòng nào còn được yêu cầu, cam kết, nhân viên hoặc bảng giá dùng thì không xóa được — hãy tắt Đang dùng thay vì xóa.",
  deleted: "Đã xóa.",
  hidden: "Đã được yêu cầu trước đây dùng nên chỉ ẩn khỏi bảng giá, không xóa.",
  on: "Đang dùng",
  off: "Tắt",
  addEntity: "Thêm pháp nhân",
  editEntity: "Sửa pháp nhân",
  addCategory: "Thêm nhóm",
  editCategory: "Sửa nhóm",
  addStaff: "Thêm nhân viên",
  editStaff: "Sửa nhân viên",
  addPrice: "Thêm giá",
  editPrice: "Sửa giá",
  entityCode: "Mã pháp nhân",
  region: "Khu vực",
  approverHint: "Nhiều email thì cách nhau bằng dấu phẩy — một người bất kỳ trong đó duyệt.",
  sortOrder: "Thứ tự",
  sortHint: "Số nhỏ hiện trước trong form yêu cầu.",
  categoryHint: "Mỗi dòng yêu cầu giữ % lúc gửi — sửa nhóm chỉ áp dụng cho yêu cầu mới.",
  fullNameField: "Họ tên",
  department: "Phòng ban",
  jobTitle: "Chức danh",
  remarks: "Ghi chú",
  seniorField: "Senior Manager trở lên (gấp đôi hạn mức chuẩn)",
  joinedHint: "Đủ điều kiện sau ba tháng.",
  itemCode: "Mã hàng",
  color: "Màu",
  srpHint: "Theo tiền tệ của pháp nhân.",
  noApprover: "chưa có người duyệt có tài khoản — chuyển admin",
  shownOf: 'Đang hiện {{n}} / {{total}} dòng',
  clearTools: 'Bỏ sắp xếp & lọc',
  nav: 'Mua hàng nhân viên',
  title: 'Mua hàng nhân viên',
  sub: 'Mua sản phẩm Helinox với giá ưu đãi nhân viên: xem hạn mức năm, ký cam kết một lần, gửi yêu cầu cho người duyệt của pháp nhân.',
  tab_mine: 'Của tôi',
  tab_queue: 'Chờ duyệt',
  tab_ledger: 'Sổ hạn mức',
  tab_setup: 'Cài đặt',
  loading: 'Đang tải…',
  close: 'Đóng',
  notOnList: 'Bạn chưa có trong danh sách nhân viên mua hàng, hoặc tài khoản portal chưa được nối với tên của bạn. Nhờ Tina Lee hoặc nhóm portal HEVN nối giúp.',
  limitYear: 'Hạn mức {{y}}',
  noLimitShort: 'Không giới hạn',
  seniorNote: "Senior Manager trở lên — gấp đôi hạn mức chuẩn",
  prorated: 'Tính theo tỷ lệ từ {{base}} (đủ điều kiện giữa năm)',
  approved: 'Đã duyệt',
  pending: 'Chờ duyệt',
  pendingHeld: '+ {{v}} đang chờ, đã giữ trong hạn mức',
  remaining: 'Còn lại',
  approverIs: 'Người duyệt: {{who}}',
  eligible: 'Đủ điều kiện từ',
  eligibleYes: 'Đã qua thử việc — được mua',
  eligibleNo: 'Chưa — ba tháng sau ngày vào làm',
  pledgeTitle: 'Cam kết không bán lại sản phẩm mua giá ưu đãi',
  pledgeEnNote: 'Quy trình {{v}}, Phụ lục. Cam kết hiển thị bằng tiếng Anh — đây là bản bạn ký.',
  fullName: 'Họ tên (thay chữ ký)',
  birth: 'Ngày sinh',
  agree: 'Tôi đã đọc và đồng ý với cam kết trên',
  sign: 'Ký cam kết',
  pledgeSigned: 'Đã ký cam kết ngày {{at}} ({{v}})',
  newRequest: 'Yêu cầu mới',
  noPriceList: 'Chưa có bảng giá của pháp nhân bạn — nhập tên sản phẩm, chọn nhóm và nhập SRP địa phương.',
  product: 'Sản phẩm',
  productPh: 'Tên sản phẩm và màu',
  typeItem: '— nhập sản phẩm không có trong danh sách —',
  limited: 'giới hạn / collab — duyệt riêng',
  category: 'Nhóm',
  pickCategory: 'Chọn nhóm',
  qty: 'SL',
  srp: 'SRP',
  srpCur: 'SRP ({{cur}})',
  net: 'Giá sau giảm',
  total: 'Tổng',
  addItem: 'Thêm món',
  remove: 'Xóa',
  afterThis: 'Còn lại sau yêu cầu này: {{v}}',
  noLimit: 'Không giới hạn năm.',
  channel: 'Nơi mua',
  note: 'Ghi chú cho người duyệt',
  submit: 'Gửi duyệt',
  sent: 'Đã gửi {{no}} cho người duyệt.',
  myRequests: 'Yêu cầu của tôi {{y}}',
  noRequests: 'Chưa có yêu cầu.',
  no: 'Số',
  employee: 'Nhân viên',
  entity: 'Pháp nhân',
  date: 'Ngày',
  items: 'Sản phẩm',
  status: 'Trạng thái',
  approver: 'Người duyệt',
  code: 'Mã giảm giá',
  action: 'Thao tác',
  review: 'Xem duyệt',
  open: 'Mở',
  st_pending: 'Chờ duyệt',
  st_approved: 'Đã duyệt',
  st_rejected: 'Từ chối',
  st_cancelled: 'Đã hủy',
  created: 'Gửi ngày {{at}} bởi {{by}}',
  remainingBefore: 'Còn lại trước yêu cầu này: {{v}} / {{limit}}',
  decided: '{{by}} quyết định ngày {{at}}',
  notePh: 'Ghi chú (không bắt buộc — lý do nếu từ chối)',
  approve: 'Duyệt',
  reject: 'Từ chối',
  codePh: 'Mã đã cấp cho website',
  paid: 'Đã trả ({{cur}})',
  paidHint: 'Khi nhập số thực trả, số đó được trừ vào hạn mức; trước đó trừ theo tổng sau giảm.',
  save: 'Lưu',
  saved: 'Đã lưu.',
  cancelReq: 'Hủy yêu cầu này',
  waitingForYou: 'Đang chờ bạn quyết định',
  allRequests: 'Mọi yêu cầu bạn được xem trong năm',
  all: 'Tất cả',
  account: 'Tài khoản portal',
  notLinked: 'chưa nối',
  setup_entities: 'Pháp nhân & hạn mức',
  setup_categories: 'Nhóm giảm giá',
  setup_staff: 'Nhân viên',
  setup_prices: 'Bảng giá',
  currency: 'Tiền tệ',
  annualLimit: 'Hạn mức năm',
  approverEmails: 'Email người duyệt',
  approverName: 'Tên người duyệt',
  settingsNote: 'Người duyệt tự mua thì chuyển cho {{self}}. Quản trị module: {{admins}}. Mail: {{mail}}.',
  discount: 'Giảm',
  active: 'Đang dùng',
  search: 'Tìm tên, pháp nhân, email',
  importStaff: 'Nhập danh sách nhân viên (.xlsx)',
  staffImported: 'Đọc {{n}} dòng: thêm {{a}}, cập nhật {{u}}.{{m}}',
  missingList: 'Không còn trong danh sách (vẫn để đang dùng)',
  joined: 'Ngày vào làm',
  importPrices: 'Nhập bảng giá (.xlsx)',
  priceHint: "Cột: Entity, Item code, Product, Color, Category, SRP, Limited, Currency (để trống = tiền của pháp nhân; giá web HINC thì KRW). Một file có thể nhiều pháp nhân; pháp nhân nào có trong file thì thay toàn bộ.",
  pricesImported: 'Đọc {{n}} dòng cho {{e}}.{{r}}',
  refused: 'Bị từ chối',
  noPrices: 'Chưa có bảng giá.',
};

const zh = {
  st_overlimit: "待超额审批",
  charged: "计入额度：{{v}}（1 {{from}} = {{rate}} {{to}}，年度固定汇率）",
  chargedShort: "= 额度计 {{v}}",
  overApproved: "{{by}} 已于 {{at}} 批准超额购买",
  overNeeds: "此申请超出额度：需先获得超额审批，然后再进行常规审批。",
  approveOver: "批准超额",
  proratedShort: "按剩余月份比例计算",
  limitFrom: "{{v}}，按年度固定汇率",
  onHold: "{{e}} 的购买暂停，直到审批人拥有门户账号。",
  fxMissing: "尚未设置 {{y}} 年 {{from}} → {{to}} 固定汇率，暂无法计算额度。由 Tina 在 设置 → 固定汇率 中填写。",
  priceIn: "价格币种",
  krwOption: "KRW — HINC 官网",
  krwRate: "按 {{y}} 年固定汇率计入额度：1 KRW = {{rate}} {{to}}。",
  krwRateMissing: "尚未设置 {{y}} 年 KRW → {{to}} 固定汇率——请联系 Tina Lee。",
  overNote: "超出额度：仍可提交，将先进行超额审批（流程第 4 条）。",
  submitOver: "提交超额审批",
  seniorLimit: "Senior Mgr+ 额度",
  seniorHint: "留空 = 年度额度的两倍。",
  limitCurrency: "额度币种",
  limitCcyHint: "仅当额度币种与显示币种不同时填写（HEMY：MYR，按年度固定汇率以 SGD 显示）。",
  managerEmails: "员工内购负责人",
  managerHint: "可查看本法人的额度台账。多个邮箱用逗号分隔。",
  krwPurchase: "员工可在 HINC 官网以 KRW 购买",
  priceCurrency: "价格币种",
  priceCcyHint: "留空 = 法人币种；HINC 官网价格填 KRW。",
  setup_fx: "固定汇率",
  addFx: "添加汇率",
  editFx: "编辑汇率",
  fxYear: "年份",
  fxFrom: "从",
  fxTo: "到",
  fxPair: "币种对",
  fxRate: "汇率",
  fxRateHint: "1 单位“从”= 多少“到”。",
  fxNote: "备注",
  fxBy: "设置人",
  fxHint: "每个币种对设一个固定汇率，每年 1 月设定并全年使用：HINC 官网购买用 KRW → VND / CNY / SGD，HEMY 额度用 MYR → SGD。",
  noFx: "尚无固定汇率。",
  tourCardsT: "今年的额度",
  tourCardsB: "年度额度、已批准金额、待审批申请占用的金额和剩余额度。Senior Mgr+ 为标准额度的两倍；年中取得资格者按比例计算。",
  tourPledgeT: "签署一次承诺书",
  tourPledgeB: "首次申请前，请阅读禁止转售承诺书，输入姓名并勾选同意。承诺书会与所签流程版本一起保存。",
  tourFormT: "提交购买申请",
  tourFormB: "逐项填写类别和当地 SRP，折扣、折后价和剩余额度会即时算出。提交后送至所属法人的审批人。",
  tourQueueT: "审批",
  tourQueueB: "等待您决定的申请以及您可查看的全部申请。打开后批准或拒绝，再记录折扣码和实付金额。",
  tourLedgerT: "额度台账",
  tourLedgerB: "每位员工全年的额度、已批准、待审批和剩余金额，可排序、筛选，并导出 Excel 供月度复核。",
  tourSetupT: "设置",
  tourSetupB: "供模块管理员使用：法人、额度与审批人、折扣类别、员工名单和价格表，均可新增、编辑、删除。",
  searchAccount: "输入姓名或邮箱搜索",
  cancel: "取消",
  edit: "编辑",
  delete: "删除",
  deleteTitle: "删除此行？",
  deleteBody: "此操作无法撤销。仍被申请、承诺书、员工或价格使用的行不会被删除 — 请改为关闭\"启用\"。",
  deleted: "已删除。",
  hidden: "已被之前的申请使用，因此从价格表中隐藏而非删除。",
  on: "启用",
  off: "停用",
  addEntity: "添加法人",
  editEntity: "编辑法人",
  addCategory: "添加类别",
  editCategory: "编辑类别",
  addStaff: "添加员工",
  editStaff: "编辑员工",
  addPrice: "添加价格",
  editPrice: "编辑价格",
  entityCode: "法人代码",
  region: "地区",
  approverHint: "多个邮箱用逗号分隔 — 其中任何一人可决定。",
  sortOrder: "顺序",
  sortHint: "数字越小在申请表中越靠前。",
  categoryHint: "申请行保留提交时的折扣 — 修改类别只影响新申请。",
  fullNameField: "姓名",
  department: "部门",
  jobTitle: "职位",
  remarks: "备注",
  seniorField: "Senior Manager 及以上（标准额度的两倍）",
  joinedHint: "三个月后取得资格。",
  itemCode: "货号",
  color: "颜色",
  srpHint: "按法人币种。",
  noApprover: "无有账号的审批人 — 转给管理员",
  shownOf: '显示 {{n}} / {{total}} 行',
  clearTools: '清除排序和筛选',
  nav: '员工内购',
  title: '员工内购',
  sub: '以员工折扣购买 Helinox 产品：查看本年度额度，签署一次承诺书，向所属法人的审批人提交申请。',
  tab_mine: '我的购买',
  tab_queue: '审批',
  tab_ledger: '额度台账',
  tab_setup: '设置',
  loading: '加载中…',
  close: '关闭',
  notOnList: '您尚未在员工内购名单中，或门户账号尚未与名单中的姓名关联。请联系 Tina Lee 或 HEVN 门户团队关联。',
  limitYear: '{{y}} 额度',
  noLimitShort: '无额度限制',
  seniorNote: "Senior Mgr+ — 标准额度的两倍",
  prorated: '按 {{base}} 比例计算（年中取得资格）',
  approved: '已批准',
  pending: '待审批',
  pendingHeld: '+ 待审批 {{v}}，已占用额度',
  remaining: '剩余',
  approverIs: '审批人：{{who}}',
  eligible: '资格起始日',
  eligibleYes: '已过试用期 — 可以购买',
  eligibleNo: '尚未 — 入职三个月后',
  pledgeTitle: '折扣产品禁止转售承诺书',
  pledgeEnNote: '流程 {{v}} 附录。承诺书以英文显示，即您签署的原文。',
  fullName: '姓名（作为签名）',
  birth: '出生日期',
  agree: '我已阅读并同意上述承诺书',
  sign: '签署承诺书',
  pledgeSigned: '承诺书已于 {{at}} 签署（{{v}}）',
  newRequest: '新申请',
  noPriceList: '您所属法人的价格表尚未导入 — 请输入产品名称、选择类别并填写当地 SRP。',
  product: '产品',
  productPh: '产品名称和颜色',
  typeItem: '— 输入列表中没有的产品 —',
  limited: '限量 / 联名 — 需单独审批',
  category: '类别',
  pickCategory: '选择类别',
  qty: '数量',
  srp: 'SRP',
  srpCur: 'SRP（{{cur}}）',
  net: '折后价',
  total: '合计',
  addItem: '添加商品',
  remove: '删除',
  afterThis: '本次申请后剩余：{{v}}',
  noLimit: '无年度额度限制。',
  channel: '购买渠道',
  note: '给审批人的备注',
  submit: '提交审批',
  sent: '{{no}} 已发送给审批人。',
  myRequests: '我的申请 {{y}}',
  noRequests: '暂无申请。',
  no: '编号',
  employee: '员工',
  entity: '法人',
  date: '日期',
  items: '商品',
  status: '状态',
  approver: '审批人',
  code: '折扣码',
  action: '操作',
  review: '审核',
  open: '打开',
  st_pending: '待审批',
  st_approved: '已批准',
  st_rejected: '已拒绝',
  st_cancelled: '已取消',
  created: '{{at}} 由 {{by}} 提交',
  remainingBefore: '申请前剩余：{{v}} / {{limit}}',
  decided: '{{by}} 于 {{at}} 决定',
  notePh: '备注（可选 — 拒绝时填写原因）',
  approve: '批准',
  reject: '拒绝',
  codePh: '为网站发放的折扣码',
  paid: '实付（{{cur}}）',
  paidHint: '填写实付金额后按实付扣减额度；在此之前按折后合计扣减。',
  save: '保存',
  saved: '已保存。',
  cancelReq: '取消此申请',
  waitingForYou: '等待您决定',
  allRequests: '本年度您可查看的全部申请',
  all: '全部',
  account: '门户账号',
  notLinked: '未关联',
  setup_entities: '法人与额度',
  setup_categories: '折扣类别',
  setup_staff: '员工',
  setup_prices: '价格表',
  currency: '币种',
  annualLimit: '年度额度',
  approverEmails: '审批人邮箱',
  approverName: '审批人姓名',
  settingsNote: '审批人本人购买转给 {{self}}。模块管理员：{{admins}}。邮件：{{mail}}。',
  discount: '折扣',
  active: '启用',
  search: '搜索姓名、法人、邮箱',
  importStaff: '导入员工名单（.xlsx）',
  staffImported: '读取 {{n}} 行：新增 {{a}}，更新 {{u}}。{{m}}',
  missingList: '已不在名单中（保持启用）',
  joined: '入职日期',
  importPrices: '导入价格表（.xlsx）',
  priceHint: "列：Entity, Item code, Product, Color, Category, SRP, Limited, Currency（留空 = 法人币种；HINC 官网价格填 KRW）。一个文件可包含多个法人；文件中的法人将整体替换。",
  pricesImported: '{{e}} 读取 {{n}} 行。{{r}}',
  refused: '已拒绝',
  noPrices: '尚未导入价格表。',
};

const dictionary = { ns: 'xStaffBuy', en, ko, vi, zh };

export default dictionary;
